import request from "@/utils/request";

// 充值recharge 超级大奖吃super 投注大奖池betting
export function getXjhgInfo(query) {
  return request({
    url: `/xjhg/info`,
    method: "get",
    params: query,
  });
}

// 领奖接口
export function getXjhgGet(query) {
  return request({
    url: "/xjhg/get",
    method: "get",
    params: query,
  });
}

// 获取历史记录
export function getXjhgHistory(query) {
  return request({
    url: "/xjhg/history",
    method: "get",
    params: query,
  });
}

// 获取任务列表
export function getXjhgMissions(query) {
  return request({
    url: "/xjhg/missions",
    method: "get",
    params: query,
  });
}

// 接受任务
export function getAcceptMission(query) {
  return request({
    url: "/xjhg/accept-mission",
    method: "get",
    params: query,
  });
}